import { CandleValueType, IndicatorSeriesType, TaFunctionId } from "./enum.js";
const AvailableExchanges = [
  // 'aax',
  // 'ascendex',
  // 'bequant',
  // 'bibox',
  // 'bigone',
  // 'binance',
  // 'binancecoinm',
  // 'binanceus',
  "binanceusdm"
  // 'bit2c',
  // 'bitbank',
  // 'bitbay',
  // 'bitbns',
  // 'bitcoincom',
  // 'bitfinex',
  // 'bitfinex2',
  // 'bitflyer',
  // 'bitforex',
  // 'bitget',
  // 'bithumb',
  // 'bitmart',
  // 'bitmex',
  // 'bitopro',
  // 'bitpanda',
  // 'bitrue',
  // 'bitso',
  // 'bitstamp',
  // 'bitstamp1',
  // 'bittrex',
  // 'bitvavo',
  // 'bkex',
  // 'bl3p',
  // 'blockchaincom',
  // 'btcalpha',
  // 'btcbox',
  // 'btcmarkets',
  // 'btctradeua',
  // 'btcturk',
  // 'buda',
  // 'bw',
  // 'bybit',
  // 'bytetrade',
  // 'cdax',
  // 'cex',
  // 'coinbase',
  // 'coinbaseprime',
  // 'coinbasepro',
  // 'coincheck',
  // 'coinex',
  // 'coinfalcon',
  // 'coinmate',
  // 'coinone',
  // 'coinspot',
  // 'crex24',
  // 'cryptocom',
  // 'currencycom',
  // 'delta',
  // 'deribit',
  // 'digifinex',
  // 'eqonex',
  // 'exmo',
  // 'flowbtc',
  // 'fmfwio',
  // 'ftx',
  // 'ftxus',
  // 'gateio',
  // 'gemini',
  // 'hitbtc',
  // 'hitbtc3',
  // 'hollaex',
  // 'huobi',
  // 'huobijp',
  // 'huobipro',
  // 'idex',
  // 'independentreserve',
  // 'indodax',
  // 'itbit',
  // 'kraken',
  // 'kucoin',
  // 'kucoinfutures',
  // 'kuna',
  // 'latoken',
  // 'lbank',
  // 'liquid',
  // 'luno',
  // 'lykke',
  // 'mercado',
  // 'mexc',
  // 'ndax',
  // 'novadax',
  // 'oceanex',
  // 'okcoin',
  // 'okex',
  // 'okex5',
  // 'okx',
  // 'paymium',
  // 'phemex',
  // 'poloniex',
  // 'probit',
  // 'qtrade',
  // 'ripio',
  // 'stex',
  // 'therock',
  // 'tidebit',
  // 'tidex',
  // 'timex',
  // 'upbit',
  // 'vcc',
  // 'wavesexchange',
  // 'wazirx',
  // 'whitebit',
  // 'woo',
  // 'xena',
  // 'yobit',
  // 'zaif',
  // 'zb',
  // 'zipmex',
  // 'zonda',
];
const AvailableTimeframes = [
  "1m",
  "3m",
  "5m",
  "15m",
  "30m",
  "1h",
  "2h",
  "4h",
  "6h",
  "8h",
  "12h",
  "1d",
  "3d",
  "1w",
  "1M"
];
const MAX_INDICATOR_BUFFER_CANDLES = 1e3;
const MIN_INDICATOR_BUFFER_CANDLES = 50;
const MAX_BACK_SIGNAL_HOURS = 12;
const MIN_BACK_SIGNAL_HOURS = 1;
const MAX_BACKTEST_HOURS = 8760;
const MIN_BACKTEST_HOURS = 1;
const MIN_PRICE_RANGE_LIMIT = 0;
const MAX_PRICE_RANGE_LIMIT = 1;
const SESSION_COOKIE_NAME = `auth-session`;
const DEFAULT_BTC = "BTC/USDT:USDT";
const DEFAULT_DONT_ORDER_AFTER_ERROR_MINUTES = 1;
const DEFAULT_SLIPPAGE = 200;
const DEFAULT_INDICATOR_BUFFER_CANDLES = 365;
const DEFAULT_BACK_SIGNAL_HOURS = 6;
const DEFAULT_BACKTEST_HOURS = 12;
const DEFAULT_PRICE_RANGE_LIMIT = 0.1;
const DEFAULT_LEVERAGE = 1;
const DEFAULT_VIRTUAL_BALANCE = 2e4;
const DEFAULT_SEED_PERCENT = 0;
const DURATION_UNITS = ["year", "month", "day", "hour", "minute", "second", "millisecond"];
const CACHE_EXPIRE_MS = 1e3;
const COUNT_CHUNK_FOR_TICKER_AND_OHLCV = 200;
const PRESET_SYMBOLS = [DEFAULT_BTC, "ETH/USDT:USDT", "SOL/USDT:USDT", "XRP/USDT:USDT", "DOGE/USDT:USDT"];
const STRATEGY_SCHEMA_VERSION = 2;
const DEFAULT_INDICATOR_TEMPLATES = [
  // SMA(7) — 메인 차트 오버레이, 노랑
  {
    funcId: TaFunctionId.SMA,
    name: "SMA",
    inputs: { optInTimePeriod: 7, inReal: CandleValueType.CLOSE },
    outputs: { outReal: { show: true } },
    series: [
      {
        type: IndicatorSeriesType.LINE,
        yAccessor: "outReal",
        line: { show: true, strokeStyle: "#F5BC00", strokeWidth: 1, strokeDasharray: "Solid" }
      }
    ]
  },
  // SMA(25) — 메인 차트 오버레이, 분홍
  {
    funcId: TaFunctionId.SMA,
    name: "SMA",
    inputs: { optInTimePeriod: 25, inReal: CandleValueType.CLOSE },
    outputs: { outReal: { show: true } },
    series: [
      {
        type: IndicatorSeriesType.LINE,
        yAccessor: "outReal",
        line: { show: true, strokeStyle: "#F722C3", strokeWidth: 1, strokeDasharray: "Solid" }
      }
    ]
  },
  // SMA(99) — 메인 차트 오버레이, 보라
  {
    funcId: TaFunctionId.SMA,
    name: "SMA",
    inputs: { optInTimePeriod: 99, inReal: CandleValueType.CLOSE },
    outputs: { outReal: { show: true } },
    series: [
      {
        type: IndicatorSeriesType.LINE,
        yAccessor: "outReal",
        line: { show: true, strokeStyle: "#8B22F7", strokeWidth: 1, strokeDasharray: "Solid" }
      }
    ]
  },
  // Volume — 별도 패널, altbar + FastMA/SlowMA 라인
  {
    funcId: TaFunctionId.VOLUME,
    name: "Volume",
    inputs: { optInFastMAPeriod: 7, optInSlowMAPeriod: 25 },
    outputs: { outVolume: { show: true }, outFastMA: { show: true }, outSlowMA: { show: true } },
    series: [
      {
        type: IndicatorSeriesType.ALTBAR,
        yAccessor: "outVolume",
        widthRatio: 0.8,
        colorBy: "candle",
        fills: [
          { show: true, color: "#2EBD858d" },
          { show: true, color: "#F6465D8d" }
        ]
      },
      {
        type: IndicatorSeriesType.LINE,
        yAccessor: "outFastMA",
        line: { show: true, strokeStyle: "#FF6D00", strokeWidth: 1, strokeDasharray: "Solid" }
      },
      {
        type: IndicatorSeriesType.LINE,
        yAccessor: "outSlowMA",
        line: { show: true, strokeStyle: "#2962FF", strokeWidth: 1, strokeDasharray: "Solid" }
      }
    ],
    newPanel: true,
    dualScale: true
  },
  // CHW (Channel and Wave) — 메인 차트 오버레이
  {
    funcId: TaFunctionId.WAVE,
    name: "CHW",
    inputs: { optInAggregationCandles: 300, opInPivotLegs: 10, optInDevThreshold: 0.1, optInPriceType: "HL" },
    outputs: { outReal: { show: true }, outHH: { show: true }, outLL: { show: true } },
    outOptions: { showLabel: false },
    series: [
      {
        displayName: "WAVE",
        type: IndicatorSeriesType.LINE,
        yAccessor: "outReal",
        line: { show: true, strokeStyle: "#2196f3", strokeWidth: 2, strokeDasharray: "Solid" }
      },
      {
        displayName: "\uD558\uB77D \uCD94\uC138\uC120",
        type: IndicatorSeriesType.LINE,
        yAccessor: "outHH",
        line: { show: true, strokeStyle: "#f6465d", strokeWidth: 1.5, strokeDasharray: "Solid" }
      },
      {
        displayName: "\uC0C1\uC2B9 \uCD94\uC138\uC120",
        type: IndicatorSeriesType.LINE,
        yAccessor: "outLL",
        line: { show: true, strokeStyle: "#2ebd85", strokeWidth: 1.5, strokeDasharray: "Solid" }
      }
    ]
  }
];
export {
  AvailableExchanges,
  AvailableTimeframes,
  CACHE_EXPIRE_MS,
  COUNT_CHUNK_FOR_TICKER_AND_OHLCV,
  DEFAULT_BACKTEST_HOURS,
  DEFAULT_BACK_SIGNAL_HOURS,
  DEFAULT_BTC,
  DEFAULT_DONT_ORDER_AFTER_ERROR_MINUTES,
  DEFAULT_INDICATOR_BUFFER_CANDLES,
  DEFAULT_INDICATOR_TEMPLATES,
  DEFAULT_LEVERAGE,
  DEFAULT_PRICE_RANGE_LIMIT,
  DEFAULT_SEED_PERCENT,
  DEFAULT_SLIPPAGE,
  DEFAULT_VIRTUAL_BALANCE,
  DURATION_UNITS,
  MAX_BACKTEST_HOURS,
  MAX_BACK_SIGNAL_HOURS,
  MAX_INDICATOR_BUFFER_CANDLES,
  MAX_PRICE_RANGE_LIMIT,
  MIN_BACKTEST_HOURS,
  MIN_BACK_SIGNAL_HOURS,
  MIN_INDICATOR_BUFFER_CANDLES,
  MIN_PRICE_RANGE_LIMIT,
  PRESET_SYMBOLS,
  SESSION_COOKIE_NAME,
  STRATEGY_SCHEMA_VERSION
};
//# sourceMappingURL=constant.js.map
